import axios from 'axios';
import { APP_BASE_URL } from 'widget/helpers/constants';
import Cookies from 'js-cookie';

export const API = axios.create({
  baseURL: APP_BASE_URL,
  withCredentials: true,
});

export const setHeader = (value, key = 'X-Auth-Token') => {
  API.defaults.headers.common[key] = value;
};

export const removeHeader = key => {
  delete API.defaults.headers.common[key];
};

// Request interceptor
// axios.interceptors.request.use(config => {
//   const token = Cookies.get('cw_conversation'); // Replace with your cookie name
//   if (token) {
//     // config.headers.Authorization = `Bearer ${token}`;
//     console.log(
//       'INTERSEPTORS Bearer request',
//       config.headers.Authorizationoken
//     );
//   }
//   return config;
// });

// Response interceptor
axios.interceptors.response.use(response => {
  const newToken = response.headers['X-Auth-Token']; // If your server sends a new token in response headers
  if (newToken) {
    Cookies.set('cw_conversation', newToken, { expires: 7, sameSite: 'Lax' }); // Replace with your cookie name and options
  }
  return response;
});
